import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {fetchMoreObjects, fetchObjects} from "../store/actions";
import EventItem from "../Components/EventItem";
import LoadMoreButton from "../Components/LoadingMoreButton";
import LiveItem from "../Components/LiveItem";
import LoadingIndicator from "../Components/LoadingIndicator";
import LiveUpdateItem from "../Components/LiveUpdateItem";


class LivesScreen extends PureComponent {
  state = {
    tab: 'new',
  }

  componentDidMount() {
    let {match} = this.props;
    let {tab = 'new'} = match.params;
    this.setState({tab,}, this.refresh)
    // this.refresh();
  }

  refresh = () => {
    let {dispatch, match} = this.props;
    console.log('match', match);
    let {tab} = this.state;
    dispatch(fetchObjects(tab === 'new' ? 'newLives' : 'updatedLives'));
  };

  onLoadMore = async () => {
    let {dispatch, newLives, updatedLives} = this.props;
    let {tab} = this.state;

    if (tab === 'new'){
      dispatch(fetchMoreObjects('newLives', newLives.next));

    } else {
      dispatch(fetchMoreObjects('updatedLives', updatedLives.next));
    }
  };

  toggleTab = async (tab) => {
    this.setState({tab,}, this.refresh)
  }

  render() {
    let {newLives, updatedLives} = this.props;
    // let {list, loadingMore, next} = newLives;
    let {tab} = this.state;
    let lives = tab === 'new' ? newLives : updatedLives;
    let {list, loadingMore, next, refreshing} = lives;

    return (
        <div className={'container-fluid'}>
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <div className="btn-toolbar btn-group btn-group-sm">
                <button onClick={() => this.toggleTab('new')}
                        className={"btn btn-" + (tab === 'new' ? 'primary' : 'light')}>最新添加</button>

                <button onClick={() => this.toggleTab('updated')}
                        className={"btn btn-" + (tab === 'updated' ? 'primary' : 'light')}>往事进展</button>
              </div>
              <br/>

              <LoadingIndicator loading={refreshing} />

              {list.map((live) => {
                return tab === 'new' ?  <LiveItem live={live} key={'live' + live.id}/> : <LiveUpdateItem live={live} key={'live'+ live.id}/>
              })}

              <br/>

              <LoadMoreButton
                  onClick={this.onLoadMore} hasNext={next} loading={loadingMore}
              />
              <br/>
              <br/>
            </div>
          </div>
        </div>
    )
  }
}

export default connect(({newLives, updatedLives}) => ({newLives, updatedLives}))(LivesScreen);
